require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.map");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vant/es/toast/style", "vant/es/toast", "vant/es/field/style", "vant/es/field", "vant/es/popup/style", "vant/es/popup", "vant/es/button/style", "vant/es/button", "@/utils/time"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vant/es/toast/style"), require("vant/es/toast"), require("vant/es/field/style"), require("vant/es/field"), require("vant/es/popup/style"), require("vant/es/popup"), require("vant/es/button/style"), require("vant/es/button"), require("@/utils/time"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.style, global.toast, global.style, global.field, global.style, global.popup, global.style, global.button, global.time);
    global.acceptanceCheckWarningList = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _style, _toast, _style2, _field, _style3, _popup, _style4, _button, _time) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-product-tool/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _toast = _interopRequireDefault(_toast);
  _field = _interopRequireDefault(_field);
  _popup = _interopRequireDefault(_popup);
  _button = _interopRequireDefault(_button);
  var _default = {
    name: "AcceptanceCheckWarningList",
    components: {
      Button: _button.default,
      Popup: _popup.default,
      Field: _field.default
    },
    data: function data() {
      var ossHost = this.$config.base.ossHost;
      return {
        ossHost: ossHost,
        list: [],
        isShowAll: false,
        loading: false,
        countArr: [],
        showModal: false,
        checkNum: '',
        step: 1,
        tagId: 0
      };
    },
    created: function created() {
      var vm = this; // const { USER_NAME } = vm.$config.keys;
      // let name = vm.$localStorage.getItem(USER_NAME);

      var uuid = vm.$localStorage.getItem('uuid') || vm.$route.query.uuid;
      var fType = vm.$strTool.filterFactoryType(uuid);

      if (fType != 'lansong') {
        vm.$router.replace({
          path: "404"
        });
        return;
      }

      vm.pageNo = 1;
      vm.loadList();
      vm.loadCount();
    },
    computed: {
      isPass: function isPass() {
        return this.checkNum > 0;
      }
    },
    methods: {
      loadList: function loadList() {
        var vm = this;
        var params = {
          pageNo: vm.pageNo,
          pageSize: 20
        };
        vm.loading = true;
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.PROBE_BASE_URL, "scrapProbe/check"),
          params: params,
          except: true
        }).then(function (res) {
          if (!res.data) {
            (0, _toast.default)("网络错误");
            return;
          }

          vm.loading = false;
          res.data.data.map(function (item) {
            item.time = (0, _time.getYMD)(item.createAt);
          });
          vm.list = vm.pageNo == 1 ? res.data.data : vm.list.concat(res.data.data);
          vm.isShowAll = res.data.data.length < 20;
        });
      },
      initData: function initData() {
        this.tagId = 0;
        this.checkNum = '';
        this.step = 1;
      },
      next: function next() {
        var vm = this;

        if (!vm.tagId) {
          (0, _toast.default)("请选择故障类型");
          return;
        }

        vm.step = 2;
      },
      postNum: function postNum() {
        var vm = this;

        if (!vm.checkNum) {
          return;
        }

        vm.tt = _toast.default.loading('加载中');
        vm.$http({
          type: "post",
          url: "".concat(vm.$config.base.PROBE_BASE_URL, "scrapProbe/check"),
          data: {
            password: vm.$config.base.password,
            size: vm.checkNum,
            tagId: "".concat(vm.tagId)
          }
        }).then(function (res) {
          vm.tt.clear();

          if (res.code != 1) {
            (0, _toast.default)(res.message);
            return;
          }

          vm.pageNo = 1;
          vm.loadList();
          vm.loadCount();
          vm.showModal = false;
          (0, _toast.default)("\u5DF2\u6210\u529F\u9A8C\u6536".concat(vm.checkNum, "\u4E2A").concat(vm.tagId == 50 ? '无法读取数据' : '气管破损', "\u7684\u63A2\u5934"));
        });
      },
      loadMore: function loadMore() {
        var vm = this;
        vm.pageNo = vm.pageNo + 1;
        vm.loadList();
      },
      createItem: function createItem() {
        this.$router.push({
          path: './addUploadImgPage'
        });
      },
      loadCount: function loadCount() {
        var vm = this;
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.PROBE_BASE_URL, "scrapProbe/count"),
          except: true
        }).then(function (res) {
          if (!res.data) {
            (0, _toast.default)("网络错误");
            return;
          }

          vm.loading = false;
          vm.countArr = res.data;
        });
      }
    }
  };
  _exports.default = _default;
});